import { createSubstore } from 'storeon-substore';
import { StoreonStore } from 'storeon';
import type { Store } from 'store/types';
import { ReviewsStore } from '../reviews-types';
import { uploadReviewPhoto } from './upload-photo-actions';
import { UPLOAD_PHOTO } from './upload-photo-constants';

const buildUploadToken = () => Symbol('upload token');

export const uploadPhoto = (parentStore: StoreonStore<ReviewsStore>, rootStore: Store) => {
  const store = createSubstore(parentStore, 'reviewsPhoto');

  store.on(UPLOAD_PHOTO.init, async (_, file) => {
    const { modelJson, orchestratorHost, useCredentials, apiKey, requestID } = rootStore.get();

    if (!modelJson.model) {
      return Promise.resolve();
    }

    const uploadToken = buildUploadToken();
    store.dispatch(UPLOAD_PHOTO.request, { file, uploadToken });

    try {
      const response = await uploadReviewPhoto(
        modelJson.model.properties.regionId,
        file,
        { orchestratorHost, useCredentials, apiKey, requestID }
      );
      store.dispatch(UPLOAD_PHOTO.success, { photoId: response.photo.id, uploadToken });
    } catch (e) {
      console.error(e);
      store.dispatch(UPLOAD_PHOTO.failure, uploadToken);
    }
  });
  store.on(UPLOAD_PHOTO.request, (state, { file, uploadToken }) => (
    [
      ...state,
      {
        isProcessing: true,
        isUploaded: false,
        isProcessingFailed: false,
        photoId: '',
        previewSrc: file.preview,
        uploadToken,
      }
    ]
  ));
  store.on(UPLOAD_PHOTO.success, (state, { photoId, uploadToken }) => (
    state.map((photo) => {
      if (photo.uploadToken === uploadToken) {
        return {
          ...photo,
          isProcessing: false,
          isUploaded: true,
          photoId,
        };
      }

      return photo;
    })
  ));
  store.on(UPLOAD_PHOTO.failure, (state, uploadToken) => (
    state.map(photo => {
      if (photo.uploadToken === uploadToken) {
        return {
          ...photo,
          isProcessing: false,
          isUploaded: false,
        };
      }

      return photo;
    })
  ));
  store.on(UPLOAD_PHOTO.delete, (state, uploadToken) => (
    state.filter(photo => {
      if (photo.uploadToken !== uploadToken) {
        return {
          ...photo,
          isProcessing: false,
          isProcessingFailed: true,
          isUploaded: false,
        };
      }
    })
  ));
};
